module.exports = __webpack_public_path__ + "static/media/upload-icon.bfcc4aa2.svg";